import { useContext } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import useInventoryConfiguration from './hooks/useInventoryConfiguration/useInventoryConfiguration'
import InventoryConfigurationSkeleton from './InventoryConfigurationSkeleton/InventoryConfigurationSkeleton'
import InventoryDefaultSection from './InventoryDefaultSection/InventoryDefaultSection'
import * as Styles from './styles'

const InventoryConfiguration = () => {
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const {
    loading,
    data,
    hasChanges,
    resetData,
    onChange,
    onSaveChanges,
    editingShipmentsConfiguration,
    regions,
    needsNsPid,
  } = useInventoryConfiguration({
    storeId: info?.selectedStore?.id,
    setToastInfo,
  })
  const { hasPermission } = useUserPermissions()

  if (loading) {
    return <InventoryConfigurationSkeleton />
  }

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editShipmentsSettings)} />}
      <InventoryDefaultSection
        regions={regions}
        defaultHsCode={data?.default_inventory_item_hs_code}
        defaultHtsCode={data?.default_inventory_item_hts_code}
        defaultMidCode={data?.default_inventory_item_mid_code}
        defaultNsPid={data?.default_inventory_item_ns_pid}
        defaultCountryCode={data?.default_inventory_item_country_from}
        defaultWeight={data?.default_inventory_item_weight}
        defaultWeightUnit={data?.default_inventory_item_weight_unit}
        needsHts={data?.needs_hts}
        needsNsPid={needsNsPid}
        onChange={onChange}
      />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editShipmentsSettings) && hasChanges}
        onSave={onSaveChanges}
        onRevertChanges={resetData}
        loading={editingShipmentsConfiguration}
        disabled={editingShipmentsConfiguration}
      />
    </Styles.Container>
  )
}

export default InventoryConfiguration
